<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
    content-class="privacy-policy-dialog"
  >
    <v-card class="privacy-policy-card">
      <v-card-title class="modal-title">
        <h2 class="title">Privacy Policy</h2>
        <button icon @click="close" class="btn-close" aria-label="Close modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </v-card-title>

      <v-card-text class="modal-content-container">
        <p>
          This Privacy Policy outlines the types of information that Eddy and
          edm8ker Inc. ("we," "us," "our") may collect from you when you visit
          our website, how we use that information, and the choices you have
          regarding our use of your personal data. By using our website, you
          agree to this Privacy Policy.
        </p>
        <h3>1. Information We Collect</h3>
        <p>
          We may collect various types of personal data from you, including:
        </p>
        <ul>
          <li>
            Contact information, such as your name, email address, phone number,
            and mailing address.
          </li>
          <li>
            Demographic information, such as your age, gender, and location.
          </li>
          <li>
            Information about your use of our website, such as your IP address,
            browser type, and operating system.
          </li>
          <li>Any other information you choose to provide to us.</li>
        </ul>

        <h3>2. How We Use Your Information</h3>
        <p>We may use your personal data for the following purposes:</p>
        <ul>
          <li>
            To provide you with the products or services you have requested.
          </li>
          <li>To personalize your experience on our website.</li>
          <li>To improve our website and the services we offer.</li>
          <li>
            To communicate with you about our products, services, and
            promotions.
          </li>
          <li>To conduct research and analytics.</li>
          <li>To comply with legal obligations.</li>
        </ul>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from "vue";

export default {
  props: {
    isOpen: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const dialog = ref(false);

    watch(
      () => props.isOpen,
      (newVal) => {
        dialog.value = newVal;
      }
    );

    watch(dialog, (newVal) => {
      if (!newVal) {
        close();
      }
    });

    const close = () => {
      emit("close");
    };

    return {
      dialog,
      close,
    };
  },
};
</script>

<style scoped>
.privacy-policy-dialog {
  border-radius: 20px;
}

.privacy-policy-card {
  border-radius: 20px;
  overflow: hidden;
  height: auto !important;
  max-height: 85vh;
}

.modal-title {
  background-color: #4c4ddc;
  padding: 14px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
}

.title {
  font-size: 40px;
  color: white;
  margin-bottom: 0;
}

.btn-close {
  font-size: 2rem;
  color: #fff;
}

.modal-content-container {
  padding: 20px 30px;
  max-height: 70vh;
  overflow-y: auto;
}

.modal-content-container::-webkit-scrollbar {
  width: 8px;
}

.modal-content-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-content-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.modal-content-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

h3 {
  margin: 1rem 0;
  color: #3b4648;
}

ul {
  margin-left: 1rem;
  padding-left: 1rem;
}

ul li {
  margin: 0;
  margin-bottom: 8px;
}
</style>
